module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index main"
  }, [(_vm.settings) ? _c('div', {
    staticClass: "page-header-wrapper",
    style: (_vm.headerStyle)
  }, [_c('div', {
    staticClass: "page-header translucent-wrapper"
  }, [_c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": _vm.handleLoadServicePhoto
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v("Загрузить фото")]), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Заголовок",
      "required": ""
    },
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.settingsObject.mainPageTitle),
      callback: function($$v) {
        _vm.$set(_vm.settingsObject, "mainPageTitle", $$v)
      },
      expression: "settingsObject.mainPageTitle"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Текст",
      "type": "textarea",
      "required": ""
    },
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.settingsObject.mainPageDescription),
      callback: function($$v) {
        _vm.$set(_vm.settingsObject, "mainPageDescription", $$v)
      },
      expression: "settingsObject.mainPageDescription"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Ссылка на видео",
      "required": ""
    },
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.settingsObject.mainPageVideo),
      callback: function($$v) {
        _vm.$set(_vm.settingsObject, "mainPageVideo", $$v)
      },
      expression: "settingsObject.mainPageVideo"
    }
  })], 1)], 1), _vm._v(" "), _c('input', {
    ref: "loadPhotoButton",
    attrs: {
      "type": "file",
      "id": "photo",
      "hidden": ""
    },
    on: {
      "change": _vm.loadPhoto
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "floating-rows drag box mt-10"
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("\n      Услуги первого типа\n    ")]), _vm._v(" "), _c('draggable', {
    staticClass: "drag-area",
    attrs: {
      "group": "order",
      "value": _vm.firstTypeServices
    },
    on: {
      "change": function($event) {
        return _vm.commonServicesChange($event, 0)
      }
    }
  }, [_vm._l((_vm.firstTypeServices), function(service) {
    return _c('ServiceItem', {
      key: service.id,
      staticClass: "row",
      attrs: {
        "service": service
      },
      on: {
        "input": _vm.commonServicesUpdated,
        "remove": _vm.commonServicesRemove
      }
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "button-wrapper centered",
    on: {
      "click": function($event) {
        return _vm.add(0)
      }
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v("\n          Добавить\n        ")])])], 2), _vm._v(" "), _c('h2', [_vm._v("\n      Услуга второго типа\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      (может содержать в себе только 1 элемент)\n    ")]), _vm._v(" "), _c('draggable', {
    staticClass: "drag-area",
    attrs: {
      "group": "order",
      "value": _vm.secondTypeServices
    },
    on: {
      "change": function($event) {
        return _vm.commonServicesChange($event, 1)
      }
    }
  }, [_vm._l((_vm.secondTypeServices), function(service) {
    return _c('ServiceItem', {
      key: service.id,
      staticClass: "row",
      attrs: {
        "service": service
      },
      on: {
        "input": _vm.commonServicesUpdated,
        "remove": _vm.commonServicesRemove
      }
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "button-wrapper centered",
    on: {
      "click": function($event) {
        return _vm.add(1)
      }
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v("\n          Добавить\n        ")])])], 2), _vm._v(" "), _c('h2', [_vm._v("\n      Услуги третьего типа\n    ")]), _vm._v(" "), _c('draggable', {
    staticClass: "drag-area",
    attrs: {
      "group": "order",
      "value": _vm.thirdTypeServices
    },
    on: {
      "change": function($event) {
        return _vm.commonServicesChange($event, 2)
      }
    }
  }, [_vm._l((_vm.thirdTypeServices), function(service) {
    return _c('ServiceItem', {
      key: service.id,
      staticClass: "row",
      attrs: {
        "service": service
      },
      on: {
        "input": _vm.commonServicesUpdated,
        "remove": _vm.commonServicesRemove
      }
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "button-wrapper centered",
    on: {
      "click": function($event) {
        return _vm.add(2)
      }
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v("\n          Добавить\n        ")])])], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "save-content-button centered"
  }, [_c('button', {
    staticClass: "button save-content",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.handleSaveMainPage()
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.disabled ? 'Идет сохранение...' : 'СОХРАНИТЬ') + "\n    ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drag-info"
  }, [_c('div', {
    staticClass: "drag-info-content"
  }, [_c('img', {
    staticClass: "drag-icon",
    attrs: {
      "src": "/static/img/icons/move.svg"
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n        Чтобы поменять местами услуги на главной удерживайте и перетаскивайте их "), _c('br'), _vm._v("\n        Порядок отображения на главной странице влияет на порядок отображения пунктов услуг в меню\n        ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0479b89e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/Index.vue
// module id = 884
// module chunks = 0